(function($) {
    $(window).on('load', function() {
        'use strict';

        // -------------------------------------------------------
        // LYTICS GETTER / SENDER
        // -------------------------------------------------------
        window.lytics = window.lytics || {};
        window.lytics.fields = window.lytics.fields || {};

        lytics.gatherData = function( form ){

            let $formFields = $( form ).find(':input'),
                formFields = [];

            $formFields.each( function(){
                let $formField = $( this ),
                    captureField = true;

                if ( $formField && $formField.val() ){
                    let formFieldTagName = ( $formField.prop( 'tagName' ) ? $formField.prop( 'tagName' ).toLowerCase() : 'input' ),
                        formFieldType = ( $formField.prop( 'type' ) ? $formField.prop( 'type' ).toLowerCase() : 'text' ),
                        fieldName = $formField.prop( 'name' );


                    if ( fieldName.substring(0, 1) === '_' ){
                        // System variables for CF7 start with _ so ignore those.
                        captureField = false;
                    }

                    if ( formFieldType === 'password' ){
                        // Don't capture password fields.
                        captureField = false;
                    }

                    if ( captureField ){
                        if ( formFieldTagName === 'select' ){
                            lytics.fields[fieldName] = $formField.find( 'option:selected').text();
                        } else if ( formFieldType === 'checkbox' ) {
                            if ( $formField.is( ':checked') ){
                                lytics.fields[fieldName] = $formField.val();
                            }
                        } else if ( fieldName === 'company' ) {
                            lytics.fields['company_name'] = $formField.val();
                        } else if ( fieldName === 'aw_login_email' ) {
                            lytics.fields['email'] = $formField.val();
                        } else {
                            lytics.fields[fieldName] = $formField.val();
                        }
                    }
                }
            });
        };

        lytics.sendData = function( data ){
            if ( typeof jstag !== 'undefined' ){
                if ( data ){
                    if (data.hasOwnProperty('Ip')){
                        lytics.fields.IP = data.Ip;
                    }
                    if (data.hasOwnProperty('Domain')){
                        lytics.fields.domain = data.Domain;
                    }
                    if (data.hasOwnProperty('Name')){
                        lytics.fields.company_by_ip = data.Name;
                    }
                    if (data.hasOwnProperty('Industry')){
                        lytics.fields.industry = data.Industry.join(',');
                    }
                    if (data.hasOwnProperty('Size')){
                        lytics.fields.company_size = data.Size.join(',');
                    }
                    if (data.hasOwnProperty('IsIsp')){
                        lytics.fields.IsISP = data.IsIsp.toString();
                    }
                    if (data.hasOwnProperty('WebsiteUrl')){
                        lytics.fields.website = data.WebsiteUrl;
                    }
                    if (data.hasOwnProperty('Phone')){
                        lytics.fields.company_phone = data.Phone;
                    }
                    if (data.hasOwnProperty('HQAddress1')){
                        lytics.fields.HQAddress = data.HQAddress1;
                    }
                    if (data.hasOwnProperty('HQCity')){
                        lytics.fields.HQCity = data.HQCity;
                    }
                    if (data.hasOwnProperty('HQZip')){
                        lytics.fields.HQZip = data.HQZip;
                    }
                    if (data.hasOwnProperty('HQState')){
                        lytics.fields.HQState = data.HQState;
                    }
                    if (data.hasOwnProperty('HQCountry')){
                        lytics.fields.HQCountry = data.HQCountry;
                    }
                    if (data.hasOwnProperty('GeoCity')){
                        lytics.fields.GeoCity = data.GeoCity;
                    }
                    if (data.hasOwnProperty('GeoState')){
                        lytics.fields.GeoState = data.GeoState;
                    }
                    if (data.hasOwnProperty('GeoCountry')){
                        lytics.fields.GeoCountry = data.GeoCountry;
                    }
                    if (data.hasOwnProperty('ParentCompany')){
                        lytics.fields.ParentCompany = data.ParentCompany;
                    }
                    if (data.hasOwnProperty('ParentAddress')){
                        lytics.fields.ParentAddress = data.ParentAddress;
                    }
                    if (data.hasOwnProperty('ParentCity')){
                        lytics.fields.ParentCity = data.ParentCity;
                    }
                    if (data.hasOwnProperty('ParentState')){
                        lytics.fields.ParentState = data.ParentState;
                    }
                    if (data.hasOwnProperty('ParentZip')){
                        lytics.fields.ParentZip = data.ParentZip;
                    }
                    if (data.hasOwnProperty('ParentCountry')){
                        lytics.fields.ParentCountry = data.ParentCountry;
                    }
                    if (data.hasOwnProperty('TickerSymbol')){
                        lytics.fields.TickerSymbol = data.TickerSymbol;
                    }
                    if (data.hasOwnProperty('StockExchange')){
                        lytics.fields.StockExchange = data.StockExchange;
                    }
                    if (data.hasOwnProperty('Revenue')){
                        lytics.fields.company_revenue = data.Revenue;
                    }
                }

                jstag.send( lytics.fields, function( data ){
                    $.each(lytics.fields, function(field){
                        delete lytics.fields[field];
                    });
                } );
            }
        };

        function checkForLyticsModal(){
            if( $( '.pf-widget.adweek' ).length){
                $( '.pf-widget.adweek' ).find('.pf-widget-cancel').html('No Thanks');
                var popupID = $('.pf-widget-modal.lead-gen:visible').attr('id');
                $('#' + popupID).find( '.pf-widget-headline').detach().prependTo( $('#' + popupID).find('.pf-widget-body') );
            }
            else {
                setTimeout( checkForLyticsModal, 400 );
            }
        }

        var lyticsTopics = $( 'meta[name="lytics:topics"]' ).attr( 'content' );

        lytics.fields.AW_Page_Topic = lyticsTopics;

        let aw_ip_info_data = Cookies.get( 'aw_ip_info_data' );

        if ( aw_ip_info_data ){
            try {
                var dataJSON = JSON.parse( aw_ip_info_data );
                if ( dataJSON ){
                    lytics.sendData( dataJSON );
                }
            }
            catch(err) { /* noop */ }
        } else {
            if (window.aw_ip_info_endpoint){
                $.ajax({
                    type: 'GET',
                    url: aw.ip_address_api_url,
                }).done(function(data) {
                    if (data && data.ip){
                        $.ajax({
                            type: 'GET',
                            url: '/aw-ip-info',
                            data: {
                                ip: data.ip
                            },
                        }).done(function(data) {
                            try {
                                var dataJSON = JSON.parse(data);
                                if ( dataJSON ){
                                    Cookies.set( 'aw_ip_info_data', data, { expires: 365 } );                                 
                                    lytics.sendData( dataJSON );
                                }
                            }
                            catch(err) { /* NOOP*/ }
                        });
                    }
                });
            }
        }

        checkForLyticsModal();

        // -------------------------------------------------------
        // LYTICS LEAD GEN FORM FIX / IP ADDRESS
        // -------------------------------------------------------

        $(document).on( 'mouseover', '.pf-widget-modal.lead-gen', function(){
            $(this).find( '.pf-widget-headline').detach().prependTo( $(this).find('.pf-widget-body') );
        });

        // -------------------------------------------------------
        // LYTICS TRACKING
        // -------------------------------------------------------

        $( 'form' ).on( 'submit', function(){
            if ( $( this ).data( 'ly-track' ) == undefined || $( this ).data( 'ly-track' ).toString() !== 'false' ){
                if ( $( this ).hasClass( 'wpcf7-form' ) ){
                    lytics.gatherData( $(this) );
                } else {
                    lytics.gatherData( $(this) );
                    lytics.sendData();
                }            
            }
        });

        // Send CF7 data to lytics if the mail sent successfully
        $('.wpcf7').on( 'wpcf7mailsent', function(){
            lytics.sendData();
        });
    });

})(jQuery);
